import { LocationCode } from '@geneplanet/ngx-utils/src/lib/localization';

import { Location, registerLocaleData } from '@angular/common';
import localeCh from '@angular/common/locales/en-CH';
import localeEnDe from '@angular/common/locales/en-DE';
import localeEnGb from '@angular/common/locales/en-GB';
import localeEnUs from '@angular/common/locales/en';
import localePl from '@angular/common/locales/pl';
import localeSl from '@angular/common/locales/sl';
import localeSk from '@angular/common/locales/sk';
import localeTh from '@angular/common/locales/th';
import {
  LocalizeRouterSettings,
  ManualParserLoader,
} from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

export function setLocaleData(locationCode: LocationCode) {
  switch (locationCode) {
    case LocationCode.CH: {
      registerLocaleData(localeCh);
      break;
    }
    case LocationCode.UK: {
      registerLocaleData(localeEnGb);
      break;
    }
    case LocationCode.US: {
      registerLocaleData(localeEnUs);
      break;
    }
    case LocationCode.SL: {
      registerLocaleData(localeSl);
      break;
    }
    case LocationCode.PL: {
      registerLocaleData(localePl);
      break;
    }
    case LocationCode.SK: {
      registerLocaleData(localeSk);
      break;
    }
    case LocationCode.EU: {
      registerLocaleData(localeEnDe);
      break;
    }
    case LocationCode.TH: {
      registerLocaleData(localeTh);
      break;
    }
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function ManualLoaderFactory(
  translate: TranslateService,
  location: Location,
  settings: LocalizeRouterSettings
) {
  return new ManualParserLoader(
    translate,
    location,
    settings,
    environment.locations.map((l) => l.code)
  );
}
